<template>
  <v-app>
    <!-- 全局 message 轻提示 -->
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :top="true"
      :absolute="true"
      :color="snackbarStatus === 'success' ? '#4caf50' : '#ff5252'"
      style="top: 24px"
    >
      {{ message }}
    </v-snackbar>

    <v-toolbar
      color="primary"
      dark
      flat
    >
      <v-toolbar-side-icon @click="mini = !mini"></v-toolbar-side-icon>
      <v-toolbar-title>APM Tenant Management Portal</v-toolbar-title>
    </v-toolbar>
    <v-dialog
      v-model="authDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Login</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Username *"
                  v-model="username"
                  required
                  @keyup.enter="validateInfo"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Password *"
                  type="password"
                  v-model="password"
                  required
                  @keyup.enter="validateInfo"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click="validateInfo"
          >Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout v-if="!authDialog">
      <v-navigation-drawer
        v-model="drawer"
        :mini-variant="mini"
        stateless
        style="height: auto; min-width: 80px"
      >
        <v-list
          class="pt-0"
          dense
        >
          <v-divider></v-divider>
          <v-list-tile
            v-for="item in items"
            :key="item.title"
            v-model="item.active"
            @click="gotoManage(item)"
          >
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-list-tile-action v-on="on">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
              </template>
              <span>{{item.title}}</span>
            </v-tooltip>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <div class="right-container">
        <div class="breadcrumb-wrapper">
          <v-breadcrumbs
            v-show="$route.name === 'TenantList' || $route.name === 'TenantInfo'"
            :items="menus"
            large
          >
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
          <v-btn
            v-show="$route.name === 'TenantList'"
            :loading="curRefeshState"
            :disabled="curRefeshState"
            color="info"
            class="white--text"
            @click="beginRefresh"
          >
            Refresh
          </v-btn>
        </div>
        <router-view></router-view>
      </div>
    </v-layout>

    <!-- 全局loading组件 -->
    <v-dialog
      v-model="loading"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-text>
          <v-progress-circular
            color="primary"
            indeterminate
            style="margin-right: 12px"
          ></v-progress-circular>
          {{loadingText}}
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <div class="water-mark">
      <div class="mark-content">APM 3.9.1</div>
      <div class="mark-content">APM Manager 3.1.3</div>
    </div> -->
  </v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: '',
  components: {
  },
  data () {
    return {
      username: '',
      password: '',
      authDialog: false,
      loadingText: 'Loading ...',
      loading: false,
      curMenuIndex: 0,
      refreshing: false,
      snackbarStatus: 'success',
      snackbar: false,
      timeout: 3000,
      message: '',
      menus: [
        {
          text: 'Tenant Management',
          disabled: true,
          href: 'TenantList'
        }
      ],
      drawer: true,
      items: [
        { title: 'Manage Tenant', icon: 'dashboard', active: true },
        { title: 'More Info', icon: 'question_answer' }
      ],
      mini: true
    }
  },
  props: {},
  computed: {
    ...mapState([
      'curRefeshState',
      'curMessage',
      'curLoadingInfo'
    ])
  },
  watch: {
    curLoadingInfo () {
      this.loading = this.curLoadingInfo.status
      this.loadingText = this.curLoadingInfo.text
    },
    curMessage () {
      if (this.curMessage.message.length > 0) {
        this.message = this.curMessage.message
        this.snackbarStatus = this.curMessage.type
        this.snackbar = true
      }
    },
    $route (to, from) {
      this.setActiveMenu(to)
      if (to.name === 'TenantInfo') {
        this.menus = [
          {
            text: 'Tenant Management',
            disabled: false,
            to: 'TenantList'
          },
          {
            text: 'Tenant Details',
            disabled: true,
            to: 'TenantInfo'
          },
          {
            text: JSON.parse(to.query.tenantInfo).tenantId,
            disabled: true,
            to: 'TenantInfo'
          }
        ]
      } else if (to.name === 'TenantList') {
        this.menus = [
          {
            text: 'Tenant Management',
            disabled: true,
            to: 'TenantList'
          }
        ]
      }
    }
  },
  created () {
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    ...mapMutations([
      'setCurMsg',
      'refreshBaseInfo',
      'setLoadingInfo'
    ]),
    validateInfo () {
      if (this.username === 'apm' && this.password === 'advantech') {
        let Base64 = require('js-base64').Base64
        let baseInfo = Base64.encode(`${this.username}:${this.password}`)
        sessionStorage.setItem('info', baseInfo)
        this.authDialog = false
        this.setCurMsg({ message: `Authentication Success.`, type: 'success' })
      } else {
        this.setCurMsg({ message: `Authentication failed.`, type: 'error' })
      }
    },
    getUserInfo () {
      let info = sessionStorage.getItem('info')
      if (info) {
        let Base64 = require('js-base64').Base64
        let baseInfo = Base64.decode(info)
        if (baseInfo.split(':')[0] === 'apm' && baseInfo.split(':')[1] === 'advantech') {
          this.authDialog = false
        }
      } else {
        this.authDialog = true
      }
    },
    beginRefresh () {
      this.refreshBaseInfo(true)
    },
    setActiveMenu (curRoute) {
      if (curRoute.name === 'TenantInfo' || curRoute.name === 'TenantList') {
        this.items[0].active = true
        this.items.forEach((item, index) => {
          if (index !== 0) {
            item.active = false
          }
        })
      } else if (curRoute.name === 'MoreInfo') {
        this.items[1].active = true
        this.items.forEach((item, index) => {
          if (index !== 1) {
            item.active = false
          }
        })
      }
    },
    gotoManage (item) {
      let title = item.title
      switch (title) {
        case 'Manage Tenant':
          this.$router.push({ name: 'TenantList' })
          break
        case 'More Info':
          this.$router.push({ name: 'MoreInfo' })
          break
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.water-mark {
  position: absolute;
  left: 12px;
  bottom: 6px;
  z-index: 9999;
  color: #787878;
  background-color: rgba(0, 0, 0, 0);
  font-family: Roboto;
  font-size: 12px;
  .mark-content {
    height: 16px;
    line-height: 16px;
  }
}
.right-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  .breadcrumb-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue